export const environment = {
  production: true,
  url: 'https://zm37ggrwgg.execute-api.ap-northeast-1.amazonaws.com/prod',
  SOCKET_ENDPOINT: 'https://intense-plains-31465.herokuapp.com/'
};
